import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContextsContextsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getContexts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/msessionMaintenance/ws_listSessions', item, options);
  }
  public getContextsCounter(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/msessionMaintenance/count', options);
  }
  public getContextInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/msessionMaintenance/ws_getSessionDetails', item, options);
  }
  public addNewContext(context, lang, udid, active, sessionName, centerInternalId, sessionContext) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, sessionName, centerInternalId, sessionContext };
    return this.http.post(this.BASE_URL + 'private/v2.0/msessionMaintenance/ws_saveSession', item, options);
  }
  public updateContextInfo(context, lang, udid, internalId, active, sessionName, centerInternalId, sessionContext) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, sessionName, centerInternalId, sessionContext };
    return this.http.post(this.BASE_URL + 'private/v2.0/msessionMaintenance/ws_saveSession', item, options);
  }
  public deleteContext(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/msessionMaintenance/ws_deleteSession', item, options);
  }
  public updateContextStatus(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/msessionMaintenance/ws_changeStatusSession', item, options);
  }
}
